import { Spin, Splitter } from "antd"
import { CSSProperties } from "react"
import Masonry from "react-masonry-css"

import ComponentErrorBoundary from "#blocks/ComponentErrorBoundary"
import Flex from "#blocks/Flex"
import { SFormHeader } from "#blocks/Form/formComponents"
import { Uuid } from "#customTypes/globalTypes"
import { Semester } from "#customTypes/types"

import StudentAttendanceListClass from "./StudentAttendanceListClass"
import useStudentAttendanceData from "./useStudentAttendanceData"

const style: CSSProperties = {
  display: "flex",
  gap: 30,
}

const StudentAttendanceList = ({
  studentId,
  semester,
}: {
  studentId: Uuid
  semester?: Semester
}) => {
  const { student, sortedAttendance, sortedAssistantAttendance, isFulfilled } =
    useStudentAttendanceData(studentId, semester)

  if (!student) return null

  const MAX_HEIGHT = 700

  return (
    <Flex col gap={30} style={{ marginBottom: 30, height: MAX_HEIGHT + 100 }}>
      <Splitter layout="vertical" style={{ height: "100%" }}>
        <Splitter.Panel style={{ paddingBottom: 20 }} max={MAX_HEIGHT}>
          <Flex col style={{ height: "100%" }}>
            <SFormHeader>Attendance</SFormHeader>

            <Flex style={{ height: "100%", overflowY: "auto" }}>
              {!isFulfilled ? (
                <Spin />
              ) : isFulfilled && sortedAttendance.length === 0 ? (
                <p>No attendance data found</p>
              ) : (
                <Masonry
                  breakpointCols={2}
                  className="masonry-grid"
                  columnClassName="masonry-grid_column"
                  style={style}
                >
                  {sortedAttendance.map((classAttendance) => (
                    <ComponentErrorBoundary
                      key={`attendance-${classAttendance.classId}`}
                      context={`Class: ${classAttendance.name}`}
                      fallbackStyle={{
                        width: 200,
                        minHeight: 80,
                        marginBottom: 10,
                      }}
                    >
                      <StudentAttendanceListClass
                        classAttendance={classAttendance}
                        student={student}
                      />
                    </ComponentErrorBoundary>
                  ))}
                </Masonry>
              )}
            </Flex>
          </Flex>
        </Splitter.Panel>

        <Splitter.Panel style={{ paddingTop: 20 }} max={MAX_HEIGHT}>
          <Flex col style={{ height: "100%" }}>
            <SFormHeader>TA Attendance</SFormHeader>

            <Flex style={{ height: "100%", overflowY: "auto" }}>
              {!isFulfilled ? (
                <Spin />
              ) : isFulfilled && sortedAssistantAttendance.length === 0 ? (
                <p>No attendance data found</p>
              ) : (
                <Masonry
                  breakpointCols={2}
                  className="masonry-grid"
                  columnClassName="masonry-grid_column"
                  style={style}
                >
                  {sortedAssistantAttendance.map((classAttendance) => (
                    <ComponentErrorBoundary
                      key={`assistant-attendance-${classAttendance.classId}`}
                      context={`TA Class: ${classAttendance.name}`}
                      fallbackStyle={{ width: 200, minHeight: 80, padding: 10 }}
                    >
                      <StudentAttendanceListClass
                        classAttendance={classAttendance}
                        student={student}
                        isAssistant
                      />
                    </ComponentErrorBoundary>
                  ))}
                </Masonry>
              )}
            </Flex>
          </Flex>
        </Splitter.Panel>
      </Splitter>
    </Flex>
  )
}

export default StudentAttendanceList
